export default `[{
  path: 'feedback',
  component: CannyWidget,
  children: [{
    path: '*',
    component: CannyWidget
  }]
}]`;
